import React from "react";
import { Helmet } from "react-helmet";
import {
  BUSINESS_NAME,
  BUSINESS_DESCRIPTION,
  BUSINESS_CONTACT_PHONE,
  BUSINESS_ADDRESS,
  BUSINESS_SOCIAL_MEDIA,
  BASE_URL,
  BUSINESS_SEO,
} from "@/core/constants/business";

// Enhanced homepage meta data with performance optimizations
const HomePageMeta = () => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{BUSINESS_SEO.defaultTitle}</title>
      <meta name="description" content={BUSINESS_SEO.defaultDescription} />
      <meta name="keywords" content={BUSINESS_SEO.defaultKeywords} />
      <link rel="canonical" href={BASE_URL} />

      {/* Enhanced Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={BASE_URL} />
      <meta property="og:title" content={BUSINESS_SEO.defaultTitle} />
      <meta
        property="og:description"
        content={BUSINESS_SEO.defaultDescription}
      />
      <meta
        property="og:image"
        content={`${BASE_URL}/images/street-lawyer-services-dc-dispensary-entrance.jpg`}
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={BUSINESS_NAME} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={BASE_URL} />
      <meta property="twitter:title" content={BUSINESS_SEO.defaultTitle} />
      <meta
        property="twitter:description"
        content={BUSINESS_SEO.defaultDescription}
      />
      <meta
        property="twitter:image"
        content={`${BASE_URL}/images/street-lawyer-services-dc-dispensary-entrance.jpg`}
      />

      {/* Performance & SEO Optimizations */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, viewport-fit=cover"
      />
      <meta name="theme-color" content="#059669" />
      <meta
        name="robots"
        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      />

      {/* Structured Data for Local Business */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Store",
          name: BUSINESS_NAME,
          description: BUSINESS_DESCRIPTION,
          url: BASE_URL,
          telephone: BUSINESS_CONTACT_PHONE,
          address: {
            "@type": "PostalAddress",
            streetAddress: "3400 Connecticut Avenue NW",
            addressLocality: "Washington",
            addressRegion: "DC",
            postalCode: "20008",
            addressCountry: "US",
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: 38.936193,
            longitude: -77.070396,
          },
          openingHours: "Mo-Su 10:00-20:00",
          priceRange: "$$",
          image: `${BASE_URL}/images/street-lawyer-services-dc-dispensary-entrance.jpg`,
          sameAs: [
            BUSINESS_SOCIAL_MEDIA.instagram,
            BUSINESS_SOCIAL_MEDIA.facebook,
            BUSINESS_SOCIAL_MEDIA.youtube,
            BUSINESS_SOCIAL_MEDIA.tiktok,
          ].filter(Boolean), // Remove any undefined social media URLs
        })}
      </script>

      {/* Resource Hints for Performance */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//maps.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
    </Helmet>
  );
};

export default HomePageMeta;
